module.exports = __webpack_public_path__ + "static/media/freedomly-logo.153ecbda.svg";